module.exports = __webpack_public_path__ + "static/media/BeatSwapLogo.00d08b35.png";